export const ANON_STORAGE_KEY = 'zxdata.anonymousRedemptions.v1';

export interface AnonymousRecord {
  code: string;
  token: string;
  // CR-8 阶段 1：lookup 双因子凭证。兑换时返回一次，需妥善保存
  lookupSecret?: string;
  datasetCode: string;
  datasetName: string;
  datasetEntityLevel: string | null;
  remainingDownloads: number;
  expiresAt: string | null;
  redeemedAt: string;
}

export function loadRecords(): Record<string, AnonymousRecord> {
  try {
    const raw = localStorage.getItem(ANON_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') return parsed as Record<string, AnonymousRecord>;
    return {};
  } catch {
    return {};
  }
}

/** 同页内通知：localStorage 的 storage 事件只跨标签触发，本标签内的变更靠这个自定义事件广播。 */
export const ANON_RECORDS_CHANGED_EVENT = 'zxdata:anon-records-changed';

export function saveRecords(records: Record<string, AnonymousRecord>) {
  localStorage.setItem(ANON_STORAGE_KEY, JSON.stringify(records));
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(ANON_RECORDS_CHANGED_EVENT));
  }
}

/** 新增/覆盖一条匿名兑换记录（按券码去重）。 */
export function addRecord(record: AnonymousRecord) {
  const records = loadRecords();
  records[record.code] = record;
  saveRecords(records);
}

export function patchRecord(code: string, patch: Partial<AnonymousRecord>) {
  const records = loadRecords();
  if (!records[code]) return;
  records[code] = { ...records[code], ...patch };
  saveRecords(records);
}

export function removeRecord(code: string) {
  const records = loadRecords();
  delete records[code];
  saveRecords(records);
}

/** 按 token 删除对应记录（认领后清理）。 */
export function removeByToken(token: string) {
  const records = loadRecords();
  const hit = Object.values(records).find((r) => r.token === token);
  if (hit) {
    delete records[hit.code];
    saveRecords(records);
  }
}

/** 收集本浏览器所有合法（64-hex）匿名 token。 */
export function collectTokens(): string[] {
  return [
    ...new Set(
      Object.values(loadRecords())
        .map((r) => r.token)
        .filter((t): t is string => typeof t === 'string' && /^[a-f0-9]{64}$/i.test(t)),
    ),
  ];
}
